import {Box, Flex, Text} from "@chakra-ui/react"
import {Link as RouterLink} from "react-router-dom"
import {IconType} from "react-icons"
import {FiArrowRight} from "react-icons/fi"

interface ChoiceCardProps {
    icon: IconType
    eyebrow: string
    title: string
    description: string
    to: string
    accent: 'blue' | 'red'
    ctaLabel: string
    onClick?: () => void
}

export default function ChoiceCard({icon: Icon, eyebrow, title, description, to, accent, ctaLabel, onClick}: ChoiceCardProps) {
    const isRed = accent === 'red'
    const iconBg = isRed ? '#FFF5F5' : '#F0F7FF'
    const iconColor = isRed ? '#FF3D3D' : '#0088FF'
    const ctaColor = iconColor

    return (
        <RouterLink to={to} onClick={onClick} style={{textDecoration: "none"}}>
            <Flex
                as="article"
                direction="column"
                gap="14px"
                p="26px 24px"
                bg="white"
                border="1px solid"
                borderColor="#E5E5E5"
                borderRadius="16px"
                boxShadow="0 1px 3px rgba(0,0,0,.05)"
                h="full"
                transition="all .18s ease"
                _hover={{
                    transform: "translateY(-3px)",
                    boxShadow: "0 4px 12px rgba(0,0,0,.08)",
                    borderColor: "#D4D4D4",
                }}
            >
                <Flex
                    w="50px"
                    h="50px"
                    borderRadius="12px"
                    bg={iconBg}
                    color={iconColor}
                    alignItems="center"
                    justifyContent="center"
                >
                    <Icon size={24}/>
                </Flex>
                <Box>
                    <Text
                        fontFamily="mono"
                        fontSize="11px"
                        letterSpacing="0.2em"
                        textTransform="uppercase"
                        color="#737373"
                        fontWeight={700}
                    >
                        {eyebrow}
                    </Text>
                    <Text fontFamily="heading" fontWeight={700} fontSize="19px" color="#171717" mt="5px">
                        {title}
                    </Text>
                    <Text fontSize="13.5px" color="#737373" mt="6px" lineHeight={1.5}>
                        {description}
                    </Text>
                </Box>
                <Flex
                    mt="auto"
                    alignItems="center"
                    gap="7px"
                    fontFamily="mono"
                    fontSize="11px"
                    letterSpacing="0.14em"
                    color={ctaColor}
                    textTransform="uppercase"
                    fontWeight={700}
                >
                    {ctaLabel} <FiArrowRight size={14}/>
                </Flex>
            </Flex>
        </RouterLink>
    )
}
